import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  IconButton,
  Typography,
  Box,
  Button,
  TextField,
  Dialog,
  Card,
  CardContent,
  Chip,
  Avatar,
  Fade,
  Slide,
  Paper,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { apiUrl } from "../../../constants";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { yellow } from "@mui/material/colors";
import "./stylees.css";
import Coin from "../../admin/Coin";
import { ToastContainer, toast } from "react-toastify";
import {
  Phone,
  Ticket,
  Activity,
  Coins,
  User,
  ChevronDown,
  ChevronUp,
  Star,
  Infinity,
  ShoppingCart,
  CheckCircle,
  Timer,
  Gift,
  Award,
  Zap,
  X,
  Code,
  Search,
  Plus,
  Minus,
} from "lucide-react";
import TokenInc from "../../navbar/tokenIncrement";

const RedeemTicket = () => {
  const [selectedColor, setSelectedColor] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const { token } = useSelector((state) => state.userSlice);
  const [ticket, setTicket] = useState({});
  const [activities, setActivities] = useState([]);
  const [shortIdInput, setshortIdInput] = useState();
  const [existingFuningoMoney, setExistingFuningoMoney] = useState(0);
  const [countDialogOpen, setCountDialogOpen] = useState(false);
  const [countTicketRedeem, setCountTicketRedeem] = useState(1);
  const [flag, setFlag] = useState({
    red: 0,
    yellow: 0,
    green: 0,
    golden: 0,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [actionModalOpen, setActionModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState(0);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();
  // manual entry
  const [ticketCode, setTicketCode] = useState("R");
  const [showCodeInput, setShowCodeInput] = useState(true);

  const handleInputChange = (price) => {
    setInputValue(price);
    setIsDropdownVisible(false);
  };
  const [activityname, setactivityname] = useState("");
  const [userIdentifier, setUserIdentifier] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [unlimitedActivities, setUnlimitedActivities] = useState([]);
  const [isUnlimitedTicket, setIsUnlimitedTicket] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState("");

  const handleSelection = async (price, name, activityId = null) => {
    setLoading(true);
    setInputValue(price);
    setSelectedColor(price);
    setactivityname(name);

    if (!activityId && !isUnlimitedTicket) {
      const selectedActivity = activities.find(
        (activity) => activity.name === name
      );
      setSelectedActivityId(
        selectedActivity?._id || selectedActivity?.id || ""
      );
    } else {
      setSelectedActivityId(activityId || "");
    }

    setIsDropdownVisible(false);
    if (!isUnlimitedTicket) {
      await fetchActivityBookings(name);
    }
    setLoading(false);

    // Open action modal after selecting activity
    setActionModalOpen(true);
  };

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  // fun to get phone number throug code
  const getPhoneNuber = async () => {
    try {
      const phoneRes = await axios.get(`${apiUrl}/ticket/t/${shortIdInput}`);
      let finalPhone = phoneRes.data.phone_no.slice(-10);
      setPhoneNo(finalPhone);
      toast.success("User Fetched");
    } catch (err) {
      console.log(err);
      toast.error("Error");
    }
  };

  const assignTrampolineSession = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${apiUrl}/chances/bulktoken`,
        {
          activityId: selectedActivityId,
          userId: phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
          userSerial: userIdentifier + serialNumber,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Trampoline session assigned successfully!");
      } else {
        toast.error(response.data.message || "Failed to assign session");
      }

      // Close all modals and reset states
      setActionModalOpen(false);
      setDialogOpen(false);
      setCountDialogOpen(false);
      resetStates();
    } catch (error) {
      console.error("Error assigning trampoline session:", error);
      toast.error("Error assigning session. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const createTokenEntry = async (userId, activityId, userName) => {
    try {
      const response = await axios.post(
        `${apiUrl}/chances/`,
        {
          userId: userId,
          activityId: activityId,
          userName: userName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error creating token entry:", error);
      throw error;
    }
  };

  // Handle Give Token action
  const handleGiveToken = async () => {
    try {
      setLoading(true);

      await createTokenEntry(
        phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
        selectedActivityId,
        userIdentifier + serialNumber
      );

      toast.success("Token given successfully!");

      // Close all modals and reset states
      setActionModalOpen(false);
      setDialogOpen(false);
      resetStates();
    } catch (error) {
      console.error("Error giving token:", error);
      toast.error("Error giving token. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Reset all states
  const resetStates = () => {
    setSelectedColor("");
    setactivityname("");
    setSelectedActivityId("");
    setInputValue(0);
    setPhoneNo("");
    setExistingFuningoMoney(0);
    setIsUnlimitedTicket(false);
    setUnlimitedActivities([]);
    setTicket({});

    setDialogOpen(false);
    setActionModalOpen(false);
    setShowCodeInput(true);
    setTicketCode("");
    setUserIdentifier("");
    setSerialNumber("");
    setActivityBookings(0);
    setSuccess(false);
    setError("");
    setError1("");
    setshortIdInput("");
    setCountDialogOpen(false);

    window.history.pushState({}, document.title, window.location.pathname);
  };

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const [error1, setError1] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [activityBookings, setActivityBookings] = useState(0);

  const handleUnlimitedTicketRedemption = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiUrl}/ticket/redeemunlimited`,
        {
          phone_no: phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
          serialno: parseInt(serialNumber),
          activityId: selectedActivityId,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const employeeUser = await axios.get(`${apiUrl}/user/`, {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        });
        const redeemByEmp = employeeUser.data.user.emp_id;
        const redeemByEmpPhone = employeeUser.data.user.phone_no;

        const resCusHistoryAdd = await axios.put(
          `${apiUrl}/user/addhistory`,
          {
            phone_no: phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
            redeemBy: redeemByEmp,
            redeemOff: phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
            coins: 0,
            activity: activityname,
          },
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        const resEmpHistoryAdd = await axios.put(
          `${apiUrl}/user/addhistory`,
          {
            phone_no: redeemByEmpPhone,
            redeemBy: redeemByEmp,
            redeemOff: phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
            coins: 0,
            activity: activityname,
          },
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        // Add activity insights
        const getCurrentDateYYYYMMDD = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          return `${year}/${month}/${day}`;
        };

        const insightActivityRes = await axios.post(
          `${apiUrl}/insights/activityadd`,
          {
            name: activityname,
            date: getCurrentDateYYYYMMDD(),
          }
        );

        const employeeinsightres = await axios.put(
          `${apiUrl}/insights/employeeactivityupdate`,
          {
            empid: redeemByEmp,
            activityName: activityname,
            count: 1,
          }
        );

        toast.success("Activity redeemed successfully!");

        // await createTokenEntry(
        //   phoneNo.length !== 10 ? phoneNo : "+91-" + phoneNo,
        //   selectedActivityId,
        //   userIdentifier + serialNumber
        // );
        setDialogOpen(false);
        setSuccess(true);

        setUnlimitedActivities((prevActivities) =>
          prevActivities
            .map((activity) => {
              if (activity.activityId === selectedActivityId) {
                const newCount = activity.count - 1;
                return { ...activity, count: newCount };
              }
              return activity;
            })
            .filter((activity) => activity.count > 0)
        );

        // Close all modals and reset
        setActionModalOpen(false);
        resetStates();
      } else {
        toast.error(response.data.message || "Failed to redeem activity");
      }
    } catch (error) {
      console.error("Error redeeming unlimited ticket:", error);
      toast.error("Error redeeming activity. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getActivityById = async (activityId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/activity/activityfetchbyid/${activityId}`,
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.activity || response.data;
    } catch (error) {
      console.error("Error fetching activity:", error);
      return null;
    }
  };

  const getActivityByIdFromList = async (activityId) => {
    try {
      const allActivities = await axios.get(`${apiUrl}/activity/activityfetch`);
      const foundActivity = allActivities.data.find(
        (act) => act._id === activityId || act.id === activityId
      );

      if (foundActivity) {
        return foundActivity;
      }

      return await getActivityById(activityId);
    } catch (error) {
      console.error("Error fetching activity from list:", error);
      return await getActivityById(activityId);
    }
  };

  const fetchUnlimitedActivities = async (unlimitedPackageData) => {
    try {
      const nonZeroActivities = unlimitedPackageData.activities.filter(
        (activity) => activity.count > 0
      );

      const activityPromises = nonZeroActivities.map(async (activity) => {
        const activityDetails = await getActivityByIdFromList(
          activity.activityId
        );
        if (activityDetails) {
          return {
            id: activity.activityId,
            name:
              activityDetails.name ||
              activityDetails.activity_name ||
              activityDetails.title ||
              `Activity ${activity.activityId}`,
            count: activity.count,
            activityId: activity.activityId,
            coins_required: activityDetails.coins_required || 0,
            ...activityDetails,
            count: activity.count,
          };
        }
        return {
          id: activity.activityId,
          name: `Activity ${activity.activityId}`,
          count: activity.count,
          activityId: activity.activityId,
          coins_required: 0,
        };
      });

      const resolvedActivities = await Promise.all(activityPromises);

      const validActivities = resolvedActivities.filter(
        (activity) => activity !== null
      );

      console.log(
        `Resolved unlimited activities for serial ${serialNumber}:`,
        validActivities
      );
      setUnlimitedActivities(validActivities);
    } catch (error) {
      console.error("Error fetching unlimited activities:", error);
      toast.error("Error fetching unlimited activities");
    }
  };

  async function fetchActivities() {
    try {
      const resActivity = await axios.get(`${apiUrl}/activity/activityfetch`);
      setActivities(resActivity.data);
    } catch (error) {
      toast.error(error.message, error);
    }
  }

  async function fetchFuningoMoney(phoneNo) {
    try {
      const headers = {
        token: token,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${apiUrl}/user/coins/${phoneNo.length === 10 ? "+91-" : ""}${phoneNo}`,
        {
          headers: headers,
        }
      );

      if (!response.data.success) {
        throw new Error("Couldn't Fetch funingo money");
      }
      setExistingFuningoMoney(response.data.funingo_money);
      setDialogOpen(true);
    } catch (error) {
      console.log(error.message, error);
    }
  }

  async function fetchActivityBookings(activityName) {
    try {
      const headers = {
        token: token,
        "Content-Type": "application/json",
      };
      const response = await axios.get(`${apiUrl}/activity/${activityName}`, {
        headers: headers,
      });

      if (!response.data.success) {
        throw new Error("Couldn't Fetch activity bookings");
      }
      setActivityBookings(response.data.bookings);
    } catch (error) {
      toast.error(error.message, error);
    }
  }

  const redeemTicket = async () => {
    try {
      if (isUnlimitedTicket) {
        await handleUnlimitedTicketRedemption();
        return;
      }
      if (existingFuningoMoney - inputValue >= 0) {
        setError("");
        setSuccess(false);
        setLoading(true);

        const res = await axios.post(
          `${apiUrl}/ticket/redeem`,
          {
            phone_no: phoneNo.length !== 4 && "+91-" + phoneNo,
            short_id: phoneNo.length === 4 && phoneNo,
            coins: inputValue,
            activity_name: activityname,
            redeemCount: countTicketRedeem,
          },
          {
            headers: {
              token,
            },
          }
        );

        const employeeUser = await axios.get(`${apiUrl}/user/`, {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        });
        const redeemByEmp = employeeUser.data.user.emp_id;
        const redeemByEmpPhone = employeeUser.data.user.phone_no;

        const resCusHistoryAdd = await axios.put(
          `${apiUrl}/user/addhistory`,
          {
            phone_no: phoneNo.length !== 4 ? "+91-" + phoneNo : phoneNo,
            redeemBy: redeemByEmp,
            redeemOff: phoneNo.length !== 4 ? "+91-" + phoneNo : phoneNo,
            coins: inputValue,
            activity: activityname,
          },
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        const resEmpHistoryAdd = await axios.put(
          `${apiUrl}/user/addhistory`,
          {
            phone_no: redeemByEmpPhone,
            redeemBy: redeemByEmp,
            redeemOff: phoneNo.length !== 4 ? "+91-" + phoneNo : phoneNo,
            coins: inputValue,
            activity: activityname,
          },
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        const getCurrentDateYYYYMMDD = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          return `${year}/${month}/${day}`;
        };

        const insightActivityRes = await axios.post(
          `${apiUrl}/insights/activityadd`,
          {
            name: activityname,
            date: getCurrentDateYYYYMMDD(),
            count: countTicketRedeem,
          }
        );
        const employeeinsightres = await axios.put(
          `${apiUrl}/insights/employeeactivityupdate`,
          {
            empid: redeemByEmp,
            activityName: activityname,
            count: countTicketRedeem,
          }
        );

        setSuccess(res.data?.success);
        fetchFuningoMoney(phoneNo);
        setActivityBookings(res.data?.bookings);
        toast.success("Coin Redeem Successfully");

        // Close all modals and reset
        setActionModalOpen(false);
        setDialogOpen(false);
        resetStates();
      } else {
        toast.warning("Insufficient Funingo Coins");
        return;
      }
    } catch (err) {
      if (existingFuningoMoney - inputValue < 0) {
        toast.warning("Insufficient Funingo Coins");
        return;
      }
      toast.error("Couldn't redeem coins, please try again!!");
    } finally {
      setLoading(false);
    }
  };

  const getDetailOfTicket = async () => {
    try {
      const ticketDetails = await axios.get(
        `${apiUrl}/ticket/get-all-tickets?phone_no=${phoneNo}`,
        {
          headers: {
            token: token,
          },
        }
      );

      if (ticketDetails.data.success && ticketDetails.data.recentTicket) {
        setTicket(ticketDetails.data.recentTicket);

        if (userIdentifier === "U") {
          const unlimitedDetail = ticketDetails.data.recentTicket.details.find(
            (detail) =>
              detail.packageType === "unlimited" &&
              detail.serialno === parseInt(serialNumber)
          );

          console.log(
            "Found unlimited detail for serial number",
            serialNumber,
            ":",
            unlimitedDetail
          );

          if (unlimitedDetail && unlimitedDetail.unlimitedPackageData) {
            setIsUnlimitedTicket(true);
            console.log(
              "Unlimited package data for serial",
              serialNumber,
              ":",
              unlimitedDetail.unlimitedPackageData
            );
            await fetchUnlimitedActivities(
              unlimitedDetail.unlimitedPackageData
            );
          } else {
            console.log(
              "No unlimited package found for serial number:",
              serialNumber
            );
            toast.error(
              `No unlimited package found for serial number ${serialNumber}`
            );
          }
        }
      }

      return ticketDetails;
    } catch (error) {
      console.error("Error fetching ticket details:", error);
      toast.error("Error fetching ticket details");
      return null;
    }
  };

  useEffect(() => {
    const tid = params.get("tid");
    if (tid) {
      const identifier = tid.charAt(0);
      setUserIdentifier(identifier);
      setShowCodeInput(false);

      if (identifier === "U") {
        const serialNum = tid.charAt(1);
        const phoneNumber = tid.slice(2);
        setSerialNumber(serialNum);
        setPhoneNo(phoneNumber);
        setTicketCode(`${identifier}${serialNum}`);
      } else {
        const last10Digits = tid.slice(-10);
        const prefixPart = tid.slice(0, -10);
        setPhoneNo(last10Digits);
        setTicketCode(identifier);
      }
    } else {
      setPhoneNo("");
      setUserIdentifier("");
      setSerialNumber("");
      setTicketCode("R");
      setShowCodeInput(true);
    }
  }, []);

  const handleGetTicketDetails = async () => {
    if (ticketCode && phoneNo && showCodeInput) {
      setShowCodeInput(false);
      const constructedTid = `${ticketCode}${phoneNo}`;
      const newUrl = `${window.location.origin}/e/redeem?tid=${constructedTid}`;
      window.location.href = newUrl;
      return;
    }

    if (userIdentifier === "R") {
      fetchFuningoMoney(phoneNo);
      fetchActivities();
    } else if (userIdentifier === "U") {
      await getDetailOfTicket();
      setDialogOpen(true);
    }
  };

  const renderActivityDropdown = () => {
    const activitiesToShow = isUnlimitedTicket
      ? unlimitedActivities
      : activities;

    return (
      <div ref={dropdownRef} style={{ position: "relative", width: "100%" }}>
        <Paper
          elevation={2}
          sx={{
            borderRadius: "8px",
            overflow: "hidden",
            border: "1px solid #e3e8ef",
            background: "#ffffff",
            transition: "border-color 0.2s ease",
            "&:hover": {
              borderColor: "#c2c9d6",
            },
          }}
        >
          <button
            onClick={toggleDropdown}
            style={{
              width: "100%",
              padding: "12px 16px",
              border: "none",
              background: "white",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "background-color 0.2s ease",
            }}
          >
            {selectedColor ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flex: 1,
                }}
              >
                <Avatar sx={{ width: 24, height: 24, bgcolor: "#6366f1" }}>
                  <Activity size={14} />
                </Avatar>
                <span style={{ color: "#374151", fontWeight: "500" }}>
                  {activityname}
                </span>
                <div
                  style={{
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    background: isUnlimitedTicket ? "#f472b6" : "#10b981",
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  {isUnlimitedTicket ? (
                    inputValue === 999 ? (
                      <>
                        <Infinity size={12} /> <span>Unlimited</span>
                      </>
                    ) : (
                      inputValue
                    )
                  ) : (
                    <>
                      <span>{inputValue}</span> <Coins size={12} />
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#6b7280",
                }}
              >
                <Activity size={16} />
                <span>Select Activity</span>
              </div>
            )}
            {isDropdownVisible ? (
              <ChevronUp size={16} />
            ) : (
              <ChevronDown size={16} />
            )}
          </button>
        </Paper>

        {isDropdownVisible && (
          <Fade in={isDropdownVisible}>
            <Paper
              elevation={4}
              sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: "400px",
                zIndex: 9999,
                borderRadius: "8px",
                overflow: "hidden",
                maxHeight: "300px",
                overflowY: "auto",
                background: "white",
                border: "1px solid #e5e7eb",
                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
              }}
            >
              <Box sx={{ p: 2, borderBottom: "1px solid #f3f4f6" }}>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#374151", fontWeight: "600" }}
                >
                  Select Activity
                </Typography>
              </Box>
              {activitiesToShow.length > 0 ? (
                activitiesToShow.map((activity, index) => (
                  <div
                    key={activity.id || activity.name || activity.activityId}
                    onClick={() =>
                      handleSelection(
                        isUnlimitedTicket
                          ? activity.count
                          : activity.coins_required,
                        activity.name,
                        activity.activityId || activity.id
                      )
                    }
                    style={{
                      padding: "12px 16px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "background-color 0.2s ease",
                      borderBottom:
                        index < activitiesToShow.length - 1
                          ? "1px solid #f9fafb"
                          : "none",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                    }}
                  >
                    <Avatar sx={{ width: 24, height: 24, bgcolor: "#6366f1" }}>
                      <Activity size={14} />
                    </Avatar>
                    <span
                      style={{
                        flex: 1,
                        fontWeight: "500",
                        color: "#374151",
                        fontSize: "14px",
                      }}
                    >
                      {activity.name}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        background: isUnlimitedTicket ? "#f472b6" : "#10b981",
                        color: "white",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "500",
                      }}
                    >
                      {isUnlimitedTicket ? (
                        activity.count === 999 ? (
                          <>
                            <Infinity size={12} /> <span>∞</span>
                          </>
                        ) : (
                          activity.count
                        )
                      ) : (
                        <>
                          <span>{activity.coins_required}</span>{" "}
                          <Coins size={12} />
                        </>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <Box sx={{ p: 2, textAlign: "center" }}>
                  <Typography variant="body2" sx={{ color: "#6b7280" }}>
                    No activities available
                  </Typography>
                </Box>
              )}
            </Paper>
          </Fade>
        )}
      </div>
    );
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        gap: 3,
      }}
    >
      <Card
        elevation={3}
        sx={{
          maxWidth: 500,
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          background: "white",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        }}
      >
        <CardContent sx={{ padding: "32px" }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Avatar
              sx={{
                width: 64,
                height: 64,
                margin: "0 auto 16px",
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              }}
            >
              {userIdentifier === "U" ? (
                <Infinity size={32} />
              ) : (
                <Phone size={32} />
              )}
            </Avatar>
            <Typography
              variant="h4"
              fontWeight="600"
              sx={{
                color: "#1f2937",
                mb: 1,
              }}
            >
              {userIdentifier === "U"
                ? "Unlimited Ticket"
                : "Ticket Redemption"}
            </Typography>
            <Typography variant="body2" sx={{ color: "#6b7280" }}>
              {userIdentifier === "U"
                ? "Redeem activities from your unlimited package"
                : "Enter phone number to redeem tickets"}
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            {showCodeInput ? (
              <TextField
                value={ticketCode}
                onChange={(e) => {
                  setTicketCode(e.target.value.toUpperCase());
                  setTicket({});
                }}
                fullWidth
                variant="outlined"
                placeholder="Enter Ticket Type (e.g., U1, R) "
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": {
                      borderColor: "#e5e7eb",
                    },
                    "&:hover fieldset": {
                      borderColor: "#d1d5db",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#6366f1",
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Avatar sx={{ width: 24, height: 24, bgcolor: "#6366f1" }}>
                      <Ticket size={14} />
                    </Avatar>
                  ),
                }}
              />
            ) : (
              <Box sx={{ mb: 2 }}>
                <Chip
                  label={`Code: ${ticketCode}`}
                  sx={{
                    bgcolor: userIdentifier === "U" ? "#fce7f3" : "#dbeafe",
                    color: userIdentifier === "U" ? "#be185d" : "#1e40af",
                    fontWeight: "500",
                  }}
                />
              </Box>
            )}

            {/* codeSection */}
            {showCodeInput ? (
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  value={shortIdInput}
                  onChange={(e) => {
                    setshortIdInput(e.target.value);
                    setTicket({});
                  }}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter Ticket Number"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& fieldset": {
                        borderColor: "#e5e7eb",
                      },
                      "&:hover fieldset": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#6366f1",
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <Avatar
                        sx={{ width: 20, height: 24, bgcolor: "#10b981" }}
                      >
                        <Code size={14} />
                      </Avatar>
                    ),
                  }}
                />
                <Button
                  onClick={getPhoneNuber}
                  variant="contained"
                  disabled={!shortIdInput}
                  sx={{
                    minWidth: "48px",
                    width: "52px",
                    height: "42px",
                    borderRadius: "8px",
                    background:
                      "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                    },
                    "&:disabled": {
                      background: "#e5e7eb",
                      color: "#9ca3af",
                    },
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    <Search size={20} />
                  )}
                </Button>
              </Box>
            ) : (
              <></>
            )}

            <TextField
              value={phoneNo}
              onChange={(e) => {
                setPhoneNo(e.target.value);
                setTicket({});
              }}
              fullWidth
              variant="outlined"
              placeholder="Enter phone number"
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": {
                    borderColor: "#e5e7eb",
                  },
                  "&:hover fieldset": {
                    borderColor: "#d1d5db",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#6366f1",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <Avatar sx={{ width: 24, height: 24, bgcolor: "#10b981" }}>
                    <Phone size={14} />
                  </Avatar>
                ),
              }}
            />

            <Button
              onClick={handleGetTicketDetails}
              fullWidth
              variant="contained"
              disabled={!phoneNo || (showCodeInput && !ticketCode) || loading}
              sx={{
                borderRadius: "8px",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                },
                "&:disabled": {
                  background: "#9ca3af",
                },
              }}
            >
              {loading ? "Loading..." : "Get Ticket Details"}
            </Button>
          </Box>

          {/* Token Increment Component */}
          <TokenInc />
        </CardContent>
      </Card>

      {/* Main Dialog for Ticket Details */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
            color: "white",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Ticket size={24} />
            Ticket Details
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            {/* User Info */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={1}
                sx={{ p: 2, borderRadius: "8px", bgcolor: "#f8fafc" }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 1, fontWeight: "600", color: "#374151" }}
                >
                  Customer Information
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <Phone size={16} />
                  <Typography variant="body2">Phone: {phoneNo}</Typography>
                </Box>
                {userIdentifier === "U" && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Ticket size={16} />
                    <Typography variant="body2">
                      Serial: {serialNumber}
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid>

            {/* Balance Info */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={1}
                sx={{ p: 2, borderRadius: "8px", bgcolor: "#f0fdf4" }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 1, fontWeight: "600", color: "#374151" }}
                >
                  Balance Information
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Coins size={16} />
                  <Typography variant="body2">
                    {isUnlimitedTicket
                      ? "Unlimited Activities"
                      : `Available Coins: ${existingFuningoMoney}`}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Activity Selection */}
            <Grid item xs={12}>
              <Paper
                elevation={1}
                sx={{ p: 2, borderRadius: "8px", bgcolor: "#fefefe" }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 2, fontWeight: "600", color: "#374151" }}
                >
                  Select Activity
                </Typography>
                {renderActivityDropdown()}
              </Paper>
            </Grid>

            {/* Success Message */}
            {success && (
              <Grid item xs={12}>
                <Paper
                  elevation={1}
                  sx={{ p: 2, borderRadius: "8px", bgcolor: "#dcfce7" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CheckCircle size={20} color="#16a34a" />
                    <Typography
                      variant="body2"
                      sx={{ color: "#16a34a", fontWeight: "500" }}
                    >
                      Ticket redeemed successfully!
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{
              color: "#6b7280",
              "&:hover": { bgcolor: "#f9fafb" },
            }}
          >
            Cancel
          </Button>
          {/* <Button
            onClick={() => {
              if (selectedColor && activityname) {
                setActionModalOpen(true);
              } else {
                toast.warning("Please select an activity first");
              }
            }}
            variant="contained"
            disabled={!selectedColor || !activityname || loading}
            sx={{
              borderRadius: "8px",
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              "&:hover": {
                background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
              },
            }}
          >
            Proceed to Redeem
          </Button> */}
        </DialogActions>
      </Dialog>

      {/* Action Modal */}
      <Dialog
        open={actionModalOpen}
        onClose={() => setActionModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            color: "white",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Activity size={24} />
            Choose Action
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 1, color: "#374151" }}>
              {activityname}
            </Typography>
            <Chip
              label={
                isUnlimitedTicket
                  ? inputValue === 999
                    ? "Unlimited Uses"
                    : `${inputValue} Uses Left`
                  : `${inputValue} Coins Required`
              }
              sx={{
                bgcolor: isUnlimitedTicket ? "#fce7f3" : "#dbeafe",
                color: isUnlimitedTicket ? "#be185d" : "#1e40af",
                fontWeight: "500",
              }}
            />
          </Box>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            {activityBookings > 0 && !isUnlimitedTicket && (
              <Grid item xs={12}>
                <Paper
                  elevation={1}
                  sx={{ p: 2, borderRadius: "8px", bgcolor: "#fef3c7" }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "#92400e", fontWeight: "500" }}
                  >
                    Current bookings for {activityname}: {activityBookings}
                  </Typography>
                </Paper>
              </Grid>
            )}
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={() => {
                  if (isUnlimitedTicket) {
                    handleUnlimitedTicketRedemption();
                  } else {
                    setCountDialogOpen(true);
                  }
                }}
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  height: "80px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(135deg, #059669 0%, #047857 100%)",
                  flexDirection: "column",
                  gap: 1,
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #047857 0%, #065f46 100%)",
                  },
                }}
              >
                <ShoppingCart size={24} />
                <Typography variant="body2" fontWeight="600">
                  {loading ? "Processing..." : "Redeem Activity"}
                </Typography>
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                onClick={
                  activityname?.toLowerCase().includes("trampoline")
                    ? assignTrampolineSession
                    : handleGiveToken
                }
                fullWidth
                variant="outlined"
                disabled={loading}
                sx={{
                  height: "80px",
                  borderRadius: "12px",
                  borderColor: "#6366f1",
                  color: "#6366f1",
                  flexDirection: "column",
                  gap: 1,
                  "&:hover": {
                    borderColor: "#4f46e5",
                    bgcolor: "#f8fafc",
                  },
                }}
              >
                {activityname?.toLowerCase().includes("trampoline") ? (
                  <Timer size={24} />
                ) : (
                  <Gift size={24} />
                )}
                <Typography variant="body2" fontWeight="600">
                  {loading
                    ? "Processing..."
                    : activityname?.toLowerCase().includes("trampoline")
                    ? "Assign Session Only"
                    : "Give Token Only"}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            onClick={() => setActionModalOpen(false)}
            fullWidth
            sx={{
              color: "#6b7280",
              "&:hover": { bgcolor: "#f9fafb" },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Count Selection Dialog */}
      <Dialog
        open={countDialogOpen}
        onClose={() => setCountDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow:
              "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
            color: "white",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "600",
            py: 2.5,
          }}
        >
          Select Redemption Count
        </DialogTitle>

        <DialogContent sx={{ p: 4, textAlign: "center" }}>
          <Typography
            variant="body2"
            sx={{
              mb: 4,
              color: "#64748b",
              fontSize: "15px",
            }}
          >
            How many times do you want to redeem this activity?
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              mb: 3,
            }}
          >
            <IconButton
              onClick={() => {
                const newCount = Math.max(1, countTicketRedeem - 1);
                setCountTicketRedeem(newCount);
                setInputValue((inputValue / countTicketRedeem) * newCount);
              }}
              sx={{
                bgcolor: "#eff6ff",
                border: "2px solid #dbeafe",
                width: "48px",
                height: "48px",
                transition: "all 0.2s",
                "&:hover": {
                  bgcolor: "#dbeafe",
                  transform: "scale(1.05)",
                },
              }}
            >
              <Minus size={22} color="#3b82f6" />
            </IconButton>

            <Box
              sx={{
                minWidth: "80px",
                py: 2,
                px: 3,
                bgcolor: "#f8fafc",
                borderRadius: "12px",
                border: "2px solid #e0e7ff",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "700",
                  color: "#3b82f6",
                  textAlign: "center",
                }}
              >
                {countTicketRedeem}
              </Typography>
            </Box>

            <IconButton
              onClick={() => {
                const newCount = countTicketRedeem + 1;
                setCountTicketRedeem(newCount);
                setInputValue((inputValue / countTicketRedeem) * newCount);
              }}
              sx={{
                bgcolor: "#eff6ff",
                border: "2px solid #dbeafe",
                width: "48px",
                height: "48px",
                transition: "all 0.2s",
                "&:hover": {
                  bgcolor: "#dbeafe",
                  transform: "scale(1.05)",
                },
              }}
            >
              <Plus size={22} color="#3b82f6" />
            </IconButton>
          </Box>

          {!isUnlimitedTicket && (
            <Box
              sx={{
                mt: 3,
                p: 2.5,
                bgcolor: "#dbeafe",
                borderRadius: "12px",
                border: "1px solid #bfdbfe",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#1e40af",
                  fontWeight: "600",
                  fontSize: "15px",
                }}
              >
                Total Coins: {inputValue}
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0, gap: 2 }}>
          <Button
            onClick={() => {
              setCountDialogOpen(false);
            }}
            fullWidth
            sx={{
              color: "#64748b",
              fontWeight: "600",
              py: 1.5,
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              "&:hover": {
                bgcolor: "#f8fafc",
                borderColor: "#cbd5e1",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (isUnlimitedTicket) {
                handleUnlimitedTicketRedemption();
              } else {
                redeemTicket();
              }
            }}
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{
              py: 1.5,
              borderRadius: "10px",
              fontWeight: "600",
              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              boxShadow: "0 4px 6px -1px rgba(16, 185, 129, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                boxShadow: "0 6px 8px -1px rgba(16, 185, 129, 0.4)",
              },
              "&:disabled": {
                background: "#d1d5db",
              },
            }}
          >
            {loading ? "Processing..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Box>
  );
};

export default RedeemTicket;
